import history from 'State/history';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import onboardingPaths from 'src/paths';
import { inaccessibleInOnboardingPaths } from 'Consts/Strings';
import { useSnackbarContext } from 'Context/SnackbarContext';

const OnboardingRedirect = () => {
  const { displayErrorMessage } = useSnackbarContext();

  useComponentDidMount(() => {
    const url = new URL(window.location.href);

    // Remove search and display error if we are redirecting from a path in inaccessibleInOnboardingPaths
    if (inaccessibleInOnboardingPaths.includes(url.pathname)) {
      url.search = '';
      url.hash = '';
      displayErrorMessage('', 'You must finish onboarding to access this link.');
    }

    url.pathname = onboardingPaths.welcome; // This must be assigned after we check the existing pathname.

    history.replace(url.pathname + url.search + url.hash);
  });

  return null;
};

export default OnboardingRedirect;
